import React,{ Component } from "react";
import Button from "../elements/Buttons";

class SendButton extends Component{
    constructor(props){
        super(props);
    }
    componentDidUpdate(newProps){
        if(this.props.disableElement!==newProps.disableElement){
            //console.log(this.props.disableElement);
        }
    }

    render(){
        const {language} = this.props;
        let classes = this.props.inputText?'chat-open mobile-size__large clicked active':'chat-open mobile-size__large clicked';
        return(
            <div id="button" data-testid="widgetButton" className={classes}>
                {/* <div className={`buttonWave ${this.props.disableElement.sendBtn?('disabled'):(null)}`}></div> */}
                <Button
                    id="button-body"
                    type="button"
                    classes="chrome bg_06 new-style"
                    title={language === 'ar'? "إرسال": "Send"}
                    dataTestid="widgetButtonBody"
                    action={this.props.sendAction}
                    areaLabel={language === 'ar'? "إرسال": "Send"}
                    svg="true"
                    disabled={this.props.disableElement.sendBtn}
                >
                    <i className="material-icons type1 for-opened active">                        
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.6626 18.1045C10.9614 18.1045 11.2188 17.9855 11.4346 17.7476C11.6504 17.5096 11.8358 17.1914 11.9907 16.793L17.4277 2.59033C17.4997 2.39665 17.555 2.2168 17.5938 2.05078C17.638 1.88477 17.6602 1.72982 17.6602 1.58594C17.6602 1.31478 17.5827 1.10173 17.4277 0.946777C17.2728 0.791829 17.0597 0.714355 16.7886 0.714355C16.6502 0.714355 16.4953 0.736491 16.3237 0.780762C16.1577 0.819499 15.9779 0.874837 15.7842 0.946777L1.50684 6.41699C1.1582 6.5498 0.864909 6.72412 0.626953 6.93994C0.388997 7.15576 0.27002 7.41309 0.27002 7.71191C0.27002 8.09375 0.400065 8.37044 0.660156 8.54199C0.920247 8.70801 1.24951 8.85189 1.64795 8.97363L6.13037 10.335C6.396 10.418 6.61458 10.4512 6.78613 10.4346C6.95768 10.4124 7.13477 10.3184 7.31738 10.1523L16.4233 1.64404C16.4731 1.59424 16.5257 1.5721 16.5811 1.57764C16.6419 1.57764 16.6945 1.59701 16.7388 1.63574C16.783 1.67448 16.8052 1.72428 16.8052 1.78516C16.8052 1.84603 16.7803 1.90137 16.7305 1.95117L8.25537 11.0903C8.09489 11.2619 8.00358 11.4334 7.98145 11.605C7.95931 11.771 7.98698 11.9924 8.06445 12.269L9.38428 16.6519C9.50602 17.0669 9.65267 17.4128 9.82422 17.6895C9.99577 17.9661 10.2752 18.1045 10.6626 18.1045Z" fill="white"/>
                        </svg>
                    </i>
                </Button>
            </div>
        )
    }
}
SendButton.propTypes = {
    sendAction: React.propTypes.node,
    disableElement: React.propTypes.node,
}
export default SendButton;